import React from "react";

// --- contact images ---
import img01 from "../../images/contact/img01.png";

// --- arrow icons ---
import arrowWhite from "../../images/icon/rotate-arrow-white02.svg";
import arrowBlack from "../../images/icon/rotate-arrow-black03.svg";
import {
  CONTACT_ADDRESS,
  CONTACT_EMAIL,
  CONTACT_MAP_URL,
  CONTACT_PHONE,
} from "../../config/contact";

const contactData = [
  {
    location: "Bangalore Office",
    address: CONTACT_ADDRESS,
    phone: CONTACT_PHONE,
    email: CONTACT_EMAIL,
    img: img01,
    mapUrl: CONTACT_MAP_URL,
  },
];

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-150">
      <div className="container">
        <div className="row mt-none-30 justify-content-center">
          {contactData.map((item, index) => (
            <div className="col-lg-6 col-md-8 mt-30" key={index}>
              <div className="xb-contact-items img-hove-effect xb-border">
                <div className="xb-item--inner">

                  {/* Multiple hover images */}
                  <div className="xb-img">
                    <a href={item.mapUrl} target="_blank" rel="noopener noreferrer">
                      <img src={item.img} alt="location" />
                    </a>
                    <a href={item.mapUrl} target="_blank" rel="noopener noreferrer">
                      <img src={item.img} alt="location" />
                    </a>
                    <a href={item.mapUrl} target="_blank" rel="noopener noreferrer">
                      <img src={item.img} alt="location" />
                    </a>
                    <a href={item.mapUrl} target="_blank" rel="noopener noreferrer">
                      <img src={item.img} alt="location" />
                    </a>
                  </div>

                  {/* Content */}
                  <div className="xb-item--holder">
                    <p className="xb-item--location">{item.location}</p>
                    <p className="xb-item--contact_info">{item.address}</p>
                    <span className="xb-item--contact_info">{item.phone}</span>
                    <span className="xb-item--contact_info">{item.email}</span>

                    <a
                      href={item.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="thm-btn form-btn mt-45"
                    >
                      VIEW LOCATION
                      <span className="xb-icon">
                        <img src={arrowWhite} alt="icon" />
                        <img src={arrowBlack} alt="icon" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
